import { getResizedImage } from 'shared-helpers/common';
import { useReduxState } from 'hooks';

const HomeBannerImage = () => {
  const { serverConfig, theme } = useReduxState();

  const bannerImage =
    theme.homePageBannerImage || serverConfig.homePageBannerImage;

  const bannerImagePosition = theme.homePageBannerImage
    ? theme.homePageBannerImagePosition
    : serverConfig.homePageBannerImagePosition;

  const asFixedSize =
    (theme.homePageBannerImage &&
      theme.homePageBannerImageLayout === 'fixed-size') ||
    (serverConfig.homePageBannerImage &&
      serverConfig.homePageBannerImageLayout === 'fixed-size');

  return (
    <>
      {bannerImage && asFixedSize ? (
        <div className="banner-image-fixed-size-wrapper">
          <div className="container">
            <div
              className="banner-image-fixed-size"
              style={{
                backgroundImage: `url(${getResizedImage({
                  url: bannerImage,
                  size: 1920
                })})`,
                backgroundPosition: bannerImagePosition,
                borderRadius: theme.cardBorderRadius
              }}
            />
          </div>
        </div>
      ) : bannerImage ? (
        <div
          className="banner-image-full-width"
          style={{
            backgroundImage: `url(${getResizedImage({
              url: bannerImage,
              size: 1920
            })})`,
            backgroundPosition: bannerImagePosition
          }}
        />
      ) : null}

      <style jsx>{`
        .banner-image-fixed-size-wrapper {
          padding: 30px 0 10px;
        }
        .banner-image-fixed-size {
          background-size: cover;
          background-position: center;
          padding-top: 20%;
        }
        .banner-image-full-width {
          background-size: cover;
          background-position: center;
          height: 260px;
        }
      `}</style>
    </>
  );
};

export default HomeBannerImage;
